import { PrefilledValues } from './helperTypes';
import { emit } from '@zapier/events-toolkit-browser';
import { WebAnalyticsTrackingUserInteractionUserInteractionEvent } from '@zapier/avro-events';
import { captureException } from '@sentry/react';

// Grabs all fields from the WebAnalyticsTrackingUserInteractionUserInteractionEvent, and removes fields that are pre-filled
// by the API or the EventsToolkit.
//
// AVRO schema: https://gitlab.com/zapier/avro-schemas/-/blob/main/schemas/web_analytics/tracking/user_interaction/user_interaction_event.avsc
type Params = Omit<
  WebAnalyticsTrackingUserInteractionUserInteractionEvent.EventFields,
  PrefilledValues | 'system_name' | 'timestamp_ms' | 'absolute_url' | 'referrer'
>;

export function dispatchUserInteractionEvent({
  event_action,
  destination_url_address,
  interaction_goal,
  interaction_name,
  custom_tracking_fields,
  experiment_flag,
  experiment_name,
  interaction_raw_text,
  node_zap_id,
  option_selected,
  zap_creation_attempt_id,
  session_id,
  account_id,
  release_id,
  visitor_id,
}: Params) {
  try {
    return emit(
      {
        system_name: 'identity',
        timestamp_ms: new Date().getTime(),
        absolute_url: window.location.toString(),
        referrer: document.referrer,
        account_id,
        node_zap_id,
        zap_creation_attempt_id,
        release_id,
        experiment_flag,
        experiment_name,
        interaction_name,
        interaction_raw_text,
        interaction_goal,
        option_selected,
        event_action,
        destination_url_address,
        custom_tracking_fields,
        session_id,
        visitor_id,
      },
      'web_analytics.tracking.user_interaction.UserInteractionEvent'
    );
  } catch (err) {
    captureException(err, {
      tags: {
        type: 'dispatchUserInteractionEvent',
      },
    });
  }
}
